import React, {useState, useEffect} from "react";
import "./LeftColumn.css";
import Toggle from "./Toggle";

import {BASE_URL} from "../router/apiClient";
import axiosClient from "../router/apiClient";

interface DataPoint {
    x: number;
    y: number;
    source: string;
    filename: string;
    imageUrl: string;
    neighbors?: DataPoint[];
}

interface LeftColumnProps {
    data: DataPoint[];
    filterImage: string;
    setFilterImage: (filename: string) => void;
    hideAPNs: boolean;
    setHideAPNs: (isOn: boolean) => void;
}

const LeftColumn: React.FC<LeftColumnProps> = ({data, filterImage, setFilterImage, hideAPNs, setHideAPNs}) => {
    const handleToggle = (isOn: boolean) => {
        setHideAPNs(isOn);
    };

    return (
        <div className="left-column">
            <div className="selected-image-title">Filtering Image</div>
            <div className="apn-images-container">
                <div className="image-grid">
                    {data.map((item) => (
                        <div
                            key={item.filename}
                            className={`image-grid-item${filterImage === item.filename ? " selected" : ""}`}
                            onClick={() =>
                                filterImage === item.filename
                                    ? setFilterImage("")
                                    : setFilterImage(item.filename)
                            }
                            aria-selected={filterImage === item.filename}
                            tabIndex={0}
                            role="button"
                        >
                            <img
                                // src={`${BASE_URL}data/images/apn/${item.filename}`}
                                src={`https://backend.${window.location.hostname}/data/images/apn/${item.filename}`}
                                alt={`Thumbnail of ${item.filename}`}
                                className="grid-image-thumb"
                            />
                        </div>
                    ))}
                </div>
            </div>
            <div className="hide-apns-container">
                <Toggle onToggle={handleToggle}
                        label={"Hide APNs"}
                        labelPlacement={"start"}
                        disabled={!filterImage}
                />
            </div>
        </div>
    );
};

export default LeftColumn;